"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Constr = void 0;
var bitstream_1 = require("@harmoniclabs/bitstream");
var Constr = /** @class */ (function () {
    function Constr(index, terms) {
        this.index = BigInt(index);
        this.terms = terms;
    }
    Object.defineProperty(Constr, "UPLCTag", {
        get: function () {
            return bitstream_1.BitStream.fromBinStr("1000");
        },
        enumerable: false,
        configurable: true
    });
    Constr.prototype.clone = function () {
        return new Constr(this.index, this.terms.map(function (term) { return term.clone(); }));
    };
    return Constr;
}());
exports.Constr = Constr;
